/**
 * Error codes the gateway returns (as the `message` of an HTTP 403) when a
 * user's Microsoft Graph access cannot be obtained. Shared with the front so
 * both sides agree on the contract.
 */
export enum AuthErrorCode {
  /** A permission was never granted (AADSTS65001): a consent popup can fix it. */
  ConsentRequired = 'consent-required',
  /** The stored session is dead (MFA, disabled account…): a popup cannot fix it. */
  ReauthRequired = 'reauth-required',
}
